export default __webpack_public_path__ + "static/media/mississippiMap.34863711.png";